import { abyssColors } from '@/theme/colors';
import {
  Box,
  Divider,
  IconButton,
  Popover,
  PopoverProps,
  TextField,
  TextFieldProps,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

type Props = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  placeholder?: string;
  popoverProps?: Partial<PopoverProps>;
  textfieldProps?: Partial<TextFieldProps>;
  submitDisabled?: boolean;
};

export const FloatingComment = ({
  open,
  anchorEl,
  onClose,
  popoverProps,
  value,
  onChange,
  onSubmit,
  placeholder,
  textfieldProps,
  submitDisabled = false,
}: Props) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      {...popoverProps}
    >
      <Box>
        <TextField
          fullWidth
          sx={{
            border: 'none',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          {...textfieldProps}
        />
        <Divider variant="fullWidth" sx={{ backgroundColor: abyssColors.primary[200] }} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={onSubmit} disabled={submitDisabled}>
            <SendIcon color="primary" />
          </IconButton>
        </Box>
      </Box>
    </Popover>
  );
};
